// extracted by mini-css-extract-plugin
module.exports = {"videoBlock":"style_videoBlock__T_h0S","videoContainer":"style_videoContainer__TLSXZ"};